export enum FilterItemInputRenderType{
    SingleBox="1",
    RangeBox="2",
    NoBox="3"
}